import { Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';

export const cliRoutes: Routes = [
    {
    path: 'saldo',
    loadChildren: () =>
      import('../pages/cli/saldo/cliente-saldo.module').then(
        (module) => module.ClienteSaldoModule
      ),
    canActivate: [AuthGuard],
  },  
  {
    path: 'indice',
    loadChildren: () =>
      import('../pages/bas/indice/indice.module').then(
        (module) => module.IndiceModule
      ),
    canActivate: [AuthGuard],
  }
  
];
